import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import { sentenceCase } from '../../utils/SentenceCase';

// Function to capitalize the first letter of each sentence
// const sentenceCase = (text) => text.replace(/(?:^|\.\s|\?\s)(\S)/g, (match, firstLetter) => firstLetter.toUpperCase());


SentenceCaseTextField.propTypes = {
    name: PropTypes.string,
    helperText: PropTypes.node,
    defaultValue: PropTypes.string,
};

export default function SentenceCaseTextField({ name, helperText, defaultValue, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field, fieldState: { error } }) => (
                <TextField
                    name={name}
                    {...field}
                    fullWidth
                    value={typeof field.value === 'number' && field.value === 0 ? '' : sentenceCase(field.value)}
                    error={!!error}
                    helperText={error ? error?.message : helperText}
                    {...other}
                />
            )}
        />
    );
}
